import script from "./SetupStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupStatusModal.vue?vue&type=script&setup=true&lang=js"

import "./SetupStatusModal.vue?vue&type=style&index=0&id=020e4a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020e4a28"]])

export default __exports__